import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import FantasyMindLogo from './FantasyMindLogo';
import Button from './Button';
import { Menu, LogOut, Settings, Trophy, BarChart3, Users } from 'lucide-react';

const Header: React.FC = () => {
  const { isAuthenticated, signIn, signOut } = useAuth();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <header className="sticky top-0 z-50 bg-bg-primary/80 backdrop-blur-sm border-b border-border-primary">
      <div className="container mx-auto px-4 py-3 md:px-6 md:py-4">
        <div className="flex items-center justify-between">
          <FantasyMindLogo />
          {!isAuthenticated && (
            <nav className="hidden md:flex items-center space-x-8">
              <a className="text-text-secondary hover:text-text-primary transition-colors font-secondary" href="#features">
                Features
              </a>
              <a className="text-text-secondary hover:text-text-primary transition-colors font-secondary" href="#pricing">
                Pricing
              </a>
            </nav>
          )}
          {isAuthenticated ? (
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="p-2 rounded-lg hover:bg-bg-tertiary transition-colors"
                aria-label="Menu"
              >
                <Menu size={24} className="text-text-primary" />
              </button>
              
              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-bg-secondary rounded-lg shadow-lg border border-border-primary py-1 z-50">
                  <button
                    onClick={() => {
                      setIsDropdownOpen(false);
                      navigate('/leagues');
                    }}
                    className="w-full px-4 py-2 text-left text-text-primary hover:bg-bg-tertiary transition-colors flex items-center gap-3"
                  >
                    <Trophy size={18} />
                    <span className="font-secondary">Leagues</span>
                  </button>
                  <button
                    onClick={() => {
                      setIsDropdownOpen(false);
                      navigate('/trade-analyzer');
                    }}
                    className="w-full px-4 py-2 text-left text-text-primary hover:bg-bg-tertiary transition-colors flex items-center gap-3"
                  >
                    <BarChart3 size={18} />
                    <span className="font-secondary">Trade Analyzer</span>
                  </button>
                  <button
                    onClick={() => {
                      setIsDropdownOpen(false);
                      navigate('/player-comparison');
                    }}
                    className="w-full px-4 py-2 text-left text-text-primary hover:bg-bg-tertiary transition-colors flex items-center gap-3"
                  >
                    <Users size={18} />
                    <span className="font-secondary">Player Comparison</span>
                  </button>
                  <button
                    onClick={() => {
                      setIsDropdownOpen(false);
                      navigate('/settings');
                    }}
                    className="w-full px-4 py-2 text-left text-text-primary hover:bg-bg-tertiary transition-colors flex items-center gap-3"
                  >
                    <Settings size={18} />
                    <span className="font-secondary">Settings</span>
                  </button>
                  <div className="border-t border-border-primary my-1"></div>
                  <button
                    onClick={() => {
                      setIsDropdownOpen(false);
                      signOut();
                      navigate('/');
                    }}
                    className="w-full px-4 py-2 text-left text-text-primary hover:bg-bg-tertiary transition-colors flex items-center gap-3"
                  >
                    <LogOut size={18} />
                    <span className="font-secondary">Sign Out</span>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Button
              onClick={signIn}
              size="small"
              className="text-sm md:text-base"
            >
              Sign In
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;